import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	titleLabel: {
		id: 'servicedesk-premium-landing-page-trigger-banner.title-label',
		defaultMessage: 'Jira Service Management',
		description: 'Title for the Premium landing page.',
	},
	subtitleLabelDefault: {
		id: 'servicedesk-premium-landing-page-trigger-banner.subtitle-label-default',
		defaultMessage: 'Some Jira Service Management Operations features will be moving to Premium.',
		description: 'Subtitle for the Premium landing page.',
	},
	subtitleLabelLoading: {
		id: 'servicedesk-premium-landing-page-trigger-banner.subtitle-label-loading',
		defaultMessage:
			'Some Jira Service Management Operations features will be moving to Premium {loadingSkeleton}',
		description:
			'Loading summary for the premium landing page trigger banner subtitle label. The loading skeleton is representing the JSM Packaging grace period end date for the user which needs time to fetch',
	},
	subtitleLabelGpEndDate: {
		id: 'servicedesk-premium-landing-page-trigger-banner.subtitle-label-gp-end-date',
		defaultMessage:
			'Some Jira Service Management Operations features will be moving to Premium on {gpEndDate}',
		description:
			'JSM Packaging grace period end date announcement subtitle label where {gpEndDate} is a formatted Date eg. Nov 04, 2025',
	},
	tryItFreeButtonLabel: {
		id: 'servicedesk-premium-landing-page-trigger-banner.ui.try-it-free-button-label',
		defaultMessage: 'Try Premium for free',
		description: 'Label for the try it free button in the Premium landing page.',
	},
});
